import { Component } from '@verndale/core';
import Swiper, { Scrollbar, Navigation } from 'swiper';

// configure Swiper to use modules
Swiper.use([Scrollbar, Navigation]);

class Module extends Component {
  setupDefaults() {
    this.isLocked = false;

    this.dom = {
      slider: this.el.querySelector('.swiper-container'),
      actions: this.el.querySelector('.video-carousel__actions'),
      previous: this.el.querySelector('.video-carousel__prev'),
      next: this.el.querySelector('.video-carousel__next'),
      scrollbar: this.el.querySelector('.video-carousel__scrollbar')
    };

    this.initSlider();
  }

  addListeners() {
    this.dom.actions.addEventListener(
      'keydown',
      this.handleKeyNavigation.bind(this)
    );
  }

  initSlider() {
    this.swiper = new Swiper(this.dom.slider, {
      slidesPerView: 'auto',
      spaceBetween: 40,
      threshold: 8,
      watchOverflow: true,
      navigation: {
        nextEl: this.dom.next,
        prevEl: this.dom.previous
      },
      scrollbar: {
        el: this.dom.scrollbar,
        draggable: true
      },
      on: {
        afterInit: swiper => {
          this.disableLinks(swiper);
          this.lockNavigation(swiper);
        },
        slideChangeTransitionStart: swiper => {
          this.disableLinks(swiper);
        },
        resize: swiper => {
          this.lockNavigation(swiper);
        }
      }
    });
  }

  lockNavigation(swiper) {
    if (this.isLocked !== swiper.isLocked) {
      this.isLocked = swiper.isLocked;
      this.dom.actions.style.display = this.isLocked ? 'none' : null;
    }
  }

  disableLinks(swiper) {
    swiper.slides.forEach(slide => {
      if (
        slide.classList.contains('swiper-slide-active') ||
        slide.classList.contains('swiper-slide-next')
      ) {
        slide
          .querySelectorAll('a')
          .forEach(link => link.removeAttribute('tabindex'));
      } else {
        slide
          .querySelectorAll('a')
          .forEach(link => link.setAttribute('tabindex', -1));
      }
    });
  }

  handleKeyNavigation(e) {
    if (e.keyCode === 37) {
      this.swiper.slidePrev();
    } else if (e.keyCode === 39) {
      this.swiper.slideNext();
    }
  }
}

export default Module;
